module.exports = __webpack_public_path__ + "img/login.ab597d96.png";